<template>
    <div class="an_pagenation">
        <div :class="'text-'+align">
            <a href="javascript:;" class="sp" @click="lastClick">上一页</a>
            <a href="javascript:;" @click="numberClick(i)" v-for="i in list" :key="i" :class="{active:currentPage===i}">{{i}}</a>
            <a href="javascript:;" class="sp" @click="nextClick">下一页</a>
        </div>
    </div>
</template>

<script>
/*方法说明
 *@description 分页组件
 *@param
    {Boolean}hasLastAndNext 是否显示上一页下一页
    {Number}startPage 开始页码
    {Number}endPage 结束页码
    {Number}currentPage 当前页码
 *@events
    lastClick 点击上一页执行
    nextClick 点击下一页执行
    numberClick 点击页码执行
*/
export default {
    name:'AnPagenation',
    props:{
        align:{
            type:String,
            default:'left'
        },
        hasLastAndNext:{
            type:Boolean,
            default:true
        },
        startPage:{
            type:Number,
            default:1
        },
        endPage:{
            type:Number,
            default:5
        },
        currentPage:{
            type:Number,
            default:1
        }
    },
    computed:{
        list(){
            let arr=[];
            for (let i=this.startPage;i<=this.endPage;i++){
                arr.push(i)
            }
            return arr;
        }
    },
    methods:{
        lastClick(){
            if(this.currentPage === 1) return;
            this.$emit('lastClick')
        },
        nextClick(){
            if(this.currentPage === this.endPage) return;
            this.$emit('nextClick')
        },
        numberClick(number){
            if(this.currentPage === number) return;
            this.$emit('numberClick',number)
        }
    }
}
</script>

<style lang="stylus">
.an_pagenation 
    a
        display inline-block
        width 40px
        height 40px
        line-height 40px
        text-align center
        border 1px solid #DDDDDD     
        margin-right 14px
        color #222222
        border-radius 4px
        &.sp
            width auto
            padding 0 10px   
        &:hover,&.active
            color #ffffff
            background #1278C6 
</style>